import {Box, Typography} from '@mui/material';
import {BlockRounded, CheckRounded, PriorityHighRounded} from '@mui/icons-material';
import {useTranslation} from 'react-i18next';
import './attendance-status-chip.scss';
import {translations} from '../../i18n/translations';

export type AttendanceStatusChipState = 'running' | 'overdue' | 'closed' | 'voided';

type AttendanceStatusChipProps = {
  state: AttendanceStatusChipState;
};

/** Status of a work session: "A decorrer agora" (with a pulsing dot), "Por fechar" or "Concluído" */
export default function AttendanceStatusChip({state}: AttendanceStatusChipProps) {
  const {t} = useTranslation();
  const texts = translations.daily_care_log.attendance_tracker.session;

  return (
    <Box className={`attendance-status-chip attendance-status-chip-${state}`}>
      {state === 'running' && <span className="pulsing-dot" />}
      {state === 'overdue' && <PriorityHighRounded />}
      {state === 'closed' && <CheckRounded />}
      {state === 'voided' && <BlockRounded />}
      <Typography>
        {t(
          state === 'running'
            ? texts.running
            : state === 'voided'
              ? translations.daily_care_log.attendance_tracker.voided.tag
              : texts[state]
        )}
      </Typography>
    </Box>
  );
}
